export default function Spinner() {
    return (
        <div style={{width: '100%', textAlign: 'center'}}>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}